import requests from "./httpService";

const SubscriberServices = {
  getAllSubscribers: async () => {
    return requests.get("/admin/subscribers/");
  },
  searchSubscriber: async (query) => {
    return requests.get(`/admin/subscribers/search_subscriber?q=${query}`);
  },
  deleteSubscriber: async (id) => {
    return requests.delete(`/admin/subscribers/delete/${id}`);
  },
  sendMail: async (body) => {
    return requests.post("admin/messages/store", body);
  },
};

export default SubscriberServices;
